import { useSelector } from 'react-redux';
import { selectFeatureFlags } from 'core/userContext';
import { EmptyStateWithContainer } from 'ui/emptyState';
import { ProvisionedEmptyState, NotProvisionedEmptyState } from 'ui/illustrations';
import { iterableLoveText } from '../../../utils';
import { useMetadata } from '../../../hooks';
import { SendingPlatform } from '../../../constants';

export const SmsAccountsEmptyState = ({
  sendingPlatform,
}: {
  sendingPlatform: SendingPlatform;
}) => {
  const { SMSSelfServeAccountSetupUI } = useSelector(selectFeatureFlags);
  const { name } = useMetadata(sendingPlatform);

  return SMSSelfServeAccountSetupUI ? (
    <EmptyStateWithContainer
      Illustration={ProvisionedEmptyState}
      title={iterableLoveText(name)}
      subtitle={`Your project is ready for SMS. Time to add your ${name} account!`}
    />
  ) : (
    <EmptyStateWithContainer
      Illustration={NotProvisionedEmptyState}
      title={iterableLoveText(name)}
      subtitle={`To get started with SMS, contact your CSM. They’ll configure your project, and then you can check back here to add your ${name} account.`}
    />
  );
};
